import API from "../helper/Api";

export default {
    state: _ => {
        return {
            user_id: false,
            login_status: null,
            permission: 'user',
            permission_loaded: false,
            user_info: {}
        }
    },
    mutations: {
        updateUserId(state, user_id) {
            state.user_id = user_id;
        },
        updateLoginStatus(state, status) {
            state.login_status = status;
        },
        updatePermission(state, permission) {
            state.permission = permission;
            state.permission_loaded = true;
        },
        updateUserInfo(state, user_info) {
            state.user_info = user_info;
        }
    },
    getters: {
        login_status(state) {
            return state.login_status;
        },
        user_permission(state) {
            return state.permission;
        },
        user_id(state) {
            return state.user_id;
        },
        user_info(state) {
            return state.user_info;
        },
        permission_loaded(state){
            return state.permission_loaded;
        }
    },
    actions: {
        checkSession(state) {
            return new Promise(function (resolve) {
                API.get("auth", "checkSession", {
                    success: session => {
                        state.commit('updateLoginStatus', session.loggedIn);
                        resolve(true);
                    },
                    error: _ => { 
                        state.commit('updateLoginStatus', false);
                    },
                });
            });
        },
        checkUserPermission(state) {
            return new Promise(function (resolve) {
                API.get("auth", "getUserInfo", {
                    success: userInfo => {
                        state.commit('updatePermission', userInfo.permission);
                        state.commit('updateUserId', userInfo.id);
                    },
                    error: _ => {
                        state.commit('updatePermission', '');
                        state.commit('updateUserId', '');
                     }
                });
                resolve(true);
            });
        },
        getUserProfile(state) {
            return new Promise(function (resolve) {
                API.get("auth", "getUserInfo", {
                    success: userInfo => {
                        state.commit("updateUserInfo", userInfo);
                    },
                    error: _ => { 
                        state.commit("updateUserInfo", {});
                    }
                });
                resolve(true);
            });
        },
        getUserProfileAndPermission(state) {
            return new Promise(function (resolve) {
                API.get("auth", "getUserInfo", {
                    success: userInfo => {
                        state.commit('updatePermission', userInfo.permission);
                        state.commit('updateUserId', userInfo.id);
                        state.commit("updateUserInfo", userInfo);
                    },
                    error: _ => {
                        state.commit('updatePermission', '');
                        state.commit('updateUserId', '');
                        state.commit("updateUserInfo", {});
                     }
                });
                resolve(true);
            });
        }
    }
};